import { ComponentPropsWithoutRef } from "react";
import styles from "./SrOnly.module.scss";
import cx from "classnames";

/**
 * Screen reader only component for providing accessible content that is visually hidden.
 *
 * Features:
 * - Visually hidden content that remains accessible to screen readers
 * - Preserves all standard span element functionality
 * - Supports custom styling and className overrides
 * - Maintains proper semantic structure
 * - Essential for accessibility compliance
 * - Works with all screen reader technologies
 * - Supports all standard HTML span attributes
 *
 * @example
 * <div>
 *   <span aria-hidden="true">$100</span>
 *   <SrOnly>One hundred dollars</SrOnly>
 * </div>
 */
export const SrOnly = (props: ComponentPropsWithoutRef<"span">) => {
  const { className, ...rest } = props;
  const classNames = cx(styles["sr-only"], className);
  return <span data-anv="sr-only" className={classNames} {...rest} />;
};
